import { useMutation } from 'providers/tanstack-query/useMutation'
import { UPDATE_AD_UNITS_PRODUCT_ENABLED } from './api/mutation'
import { Data, Variables } from './api/types'
import { useSnackbar } from './useSnackbar'

export const useSwitchAdUnitsProduct = () => {
  const { snackbar } = useSnackbar()

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_AD_UNITS_PRODUCT_ENABLED,
    onCompleted: async (data, variables) => {
      const {
        input: { enabledValue, productType },
      } = variables
      const { updateAdUnitsProductEnabled } = data

      if (updateAdUnitsProductEnabled) {
        const { errors } = updateAdUnitsProductEnabled

        if (errors && errors.length > 0) {
          snackbar(productType, enabledValue, 'error')
        } else {
          snackbar(productType, enabledValue)
        }
      }
    },
    queriesToInvalidate: ['getAdUnitsForTable'],
  })

  const update = (variables: Variables): void => void mutateAsync({ input: variables })

  return { update }
}
